export default __webpack_public_path__ + "static/media/error_bg.3acd2285.png";